import {useContext, useEffect, useRef} from 'react';

import {OrderListContext} from "../context/OrderListContext";
import {DateRangePickerContext} from "contexts/DateRangePickerContext";
import {isPeriodNeutralized} from "../utils/isPeriodNeutralized";

// Mirrors handleSearch in src/views/picking/order/list.js: debounced, a
// search overrides the date range (searching should span every date), and
// clearing it restores the currently selected date range.
const SEARCH_DEBOUNCE_MS = 500;

function SearchQueryParamsSync() {
    const {search, setQueryParams} = useContext(OrderListContext);
    const {startDate, endDate} = useContext(DateRangePickerContext);

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;

            return;
        }

        const timer = setTimeout(() => {
            setQueryParams((previousQueryParams) => {
                const params = new URLSearchParams(previousQueryParams);

                if (search.length > 0) {
                    params.set('search', search);
                    params.delete('createdAt[after]');
                    params.delete('createdAt[before]');
                } else {
                    params.delete('search');

                    // a receipt value filter may still be neutralizing the period
                    if (startDate && endDate && !isPeriodNeutralized(params)) {
                        params.set('createdAt[after]', startDate.clone().startOf('day').format('YYYY-M-D HH:mm:ss'));
                        params.set('createdAt[before]', endDate.clone().endOf('day').format('YYYY-M-D HH:mm:ss'));
                    }
                }

                params.set('page', '1');

                return params.toString();
            });
        }, SEARCH_DEBOUNCE_MS);

        return () => clearTimeout(timer);
    }, [search, setQueryParams]);

    return null;
}

export default SearchQueryParamsSync;
